import { AdminNavItem } from "@fadmin/components/manageNavItem";
import { NavItem, NavItems } from "@helpers/navigation";

export const ResultsNav = (): JSX.Element => {
    const navItems = [NavItems.Admin.Results.parentRoot, NavItems.Admin.Results.Archived] as NavItem[];

    return (
        <div className="tabs is-boxed px-5 has-background-primary-dark is-size-7 has-text-weight-medium">
            <ul>
                {navItems.map((x, i) => (
                    <AdminNavItem key={`results-nav-item-${i}`} item={x} />
                ))}
            </ul>
        </div>
    );
};
